import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useNavigate, useParams } from "react-router-dom";
import WarehouseService from "../../services/WarehouseService";

export default function WarehouseEditPage() {
  const [warehouse, setWarehouse] = useState({ id: 0, name: "", address: "" });
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      loadWarehouse(id);
    }
  }, [id]);

  const loadWarehouse = async (warehouseId) => {
    try {
      const res = await WarehouseService.getById(warehouseId);
      if (res.success && res.data) {
        setWarehouse(res.data);
      }
    } catch (error) {
      console.error("Depo yüklenirken hata oluştu:", error);
    }
  };

  const handleSave = async () => {
    if (!warehouse.name) return;
    setLoading(true);
    try {
      const res = await WarehouseService.update(warehouse);
      if (res.success) {
        navigate("/warehouses");
      }
    } catch (error) {
      console.error("Depo güncellenirken hata oluştu:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 flex justify-center">
      <div className="bg-white shadow-lg border border-slate-200 rounded-2xl p-6 w-full max-w-2xl">
        <div className="flex items-center gap-3 mb-8">
          <div className="!bg-blue-600 p-3 rounded-xl shadow-md">
            <i className="pi pi-pencil text-white text-xl"></i>
          </div>
          <div>
            <h1 className="text-xl md:text-2xl font-black text-slate-900 uppercase tracking-tight">
              Depo Tanımını Düzenle
            </h1>
          </div>
        </div>

        <div className="space-y-6">
          <div className="flex flex-col gap-2">
            <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              Depo Adı <span className="text-red-500">*</span>
            </label>
            <InputText
              value={warehouse.name}
              onChange={(e) => setWarehouse({ ...warehouse, name: e.target.value })}
              className="w-full rounded-xl border-slate-200 py-3 font-bold"
              placeholder="Örn: Merkez Depo"
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-xs font-black text-slate-500 uppercase tracking-widest ml-1">
              Adres
            </label>
            <InputTextarea
              value={warehouse.address}
              onChange={(e) => setWarehouse({ ...warehouse, address: e.target.value })}
              className="w-full rounded-xl border-slate-200 py-3 font-bold"
              rows={4}
              placeholder="Deponun açık adresi..."
            />
          </div>

          <div className="flex justify-end gap-3 pt-4">
            <Button
              label="İPTAL"
              icon="pi pi-times"
              className="p-button-text font-black text-slate-400"
              onClick={() => navigate("/warehouses")}
            />
            <Button
              label="GÜNCELLE"
              icon="pi pi-save"
              className="!bg-blue-600 border-none rounded-xl px-10 py-3.5 font-black text-sm shadow-lg transition-all hover:scale-[1.02]"
              onClick={handleSave}
              loading={loading}
              disabled={!warehouse.name}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
